"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextTruncated;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/styles");
const useStyles = (0, _styles.makeStyles)(theme => ({
  arrow: {
    color: "".concat(theme.palette.TwClrBg, " !important"),
    '&:before': {
      border: "1px solid ".concat(theme.palette.TwClrBrdrTertiary)
    }
  },
  popper: {
    maxHeight: '200px',
    overflow: 'auto'
  },
  tooltip: {
    backgroundColor: "".concat(theme.palette.TwClrBg, " !important"),
    color: "".concat(theme.palette.TwClrTxt, " !important"),
    border: "1px solid ".concat(theme.palette.TwClrBrdrTertiary, " !important"),
    borderRadius: '8px !important',
    boxShadow: "0px 3px 3px ".concat(theme.palette.TwClrBaseGray100),
    padding: '8px'
  }
}));

/**
 * Represents the result of truncating the string list
 * text: the text to display before the '...# more' link
 * numberMore: the number to display in the '...# more' link
 *   has two special values
 *   0: the full text can be displayed; do not show '...# more'
 *   -1: the list is of length one but the element cannot be fully
 *       displayed. show '...more' without a '#'
 */

/**
 * Compute TextDisplay for a list of strings
 * @param strings list of strings to process
 * @param maxLength max displayable length
 */
function computeFromStringList(strings, maxLength, listSeparator) {
  if (strings.length === 0) {
    return {
      text: '',
      numberMore: 0
    };
  }
  if (strings[0].length > maxLength) {
    // case in which the first string is too long to fit by itself
    return {
      text: strings[0].substring(0, maxLength),
      numberMore: strings.length === 1 ? -1 : strings.length - 1
    };
  }

  // concatenate strings with ', ' and stop before exceeding max
  let stringsRemaining = strings.length - 1;
  let result = strings[0];
  for (let i = 1; i < strings.length; i++) {
    const tempResult = [result, strings[i]].join(listSeparator);
    if (tempResult.length > maxLength) {
      break;
    }
    stringsRemaining--;
    result = tempResult;
  }
  return {
    text: result,
    numberMore: stringsRemaining
  };
}
function TextTruncated(props) {
  const {
    stringList,
    listSeparator,
    maxLengthPx,
    moreSeparator,
    moreText,
    textStyle,
    showAllStyle,
    placeHolder
  } = props;
  const [showAllOpen, setShowAllOpen] = (0, _react.useState)(false);
  const classes = useStyles();
  const [canvasContext, setCanvasContext] = (0, _react.useState)();
  const theme = (0, _material.useTheme)();
  (0, _react.useEffect)(() => {
    var _canvas$getContext;
    const canvas = document.createElement('canvas');
    setCanvasContext((_canvas$getContext = canvas === null || canvas === void 0 ? void 0 : canvas.getContext('2d')) !== null && _canvas$getContext !== void 0 ? _canvas$getContext : undefined);
  }, []);
  const pixelsPerChar = (0, _react.useMemo)(() => {
    // compute the pixels per character, averaged over the comma-separated joined stringList
    const fullText = stringList.join(listSeparator);
    let result = 0;
    if (canvasContext) {
      const fontSize = textStyle && textStyle.fontSize || theme.typography.fontSize;
      const fontFamily = textStyle && textStyle.fontFamily || theme.typography.fontFamily;
      canvasContext.font = "".concat(fontSize, "px ").concat(fontFamily);
      result = canvasContext.measureText(fullText).width;
    }
    return result / fullText.length;
  }, [stringList, textStyle, canvasContext, theme.typography.fontFamily, theme.typography.fontSize]);
  let maxExcludingSuffix = stringList.join(listSeparator).length;
  if (pixelsPerChar > 0) {
    const maxChars = maxLengthPx / pixelsPerChar;
    maxExcludingSuffix = maxChars - moreSeparator.length - moreText.length - 1 - Math.ceil(Math.log10(stringList.length));
  }
  const textToDisplay = computeFromStringList(stringList, maxExcludingSuffix, listSeparator);
  const onClickHandler = e => {
    e.stopPropagation();
    setShowAllOpen(!showAllOpen);
  };
  return stringList.length > 0 ? /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: textStyle
  }, textToDisplay.text, textToDisplay.numberMore !== 0 ? moreSeparator : '', textToDisplay.numberMore !== 0 ? /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    classes: {
      arrow: classes.arrow,
      popper: classes.popper,
      tooltip: classes.tooltip
    },
    open: showAllOpen,
    title: /*#__PURE__*/_react.default.createElement(_material.Typography, {
      sx: showAllStyle,
      fontSize: "14px"
    }, stringList.join(listSeparator))
  }, /*#__PURE__*/_react.default.createElement(_material.Link, {
    component: "button",
    onClick: onClickHandler,
    onBlur: () => setShowAllOpen(false),
    sx: {
      color: theme.palette.TwClrTxtBrand,
      textDecorationColor: "".concat(theme.palette.TwClrTxtBrand, "80")
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      ...textStyle,
      marginTop: '-3px'
    }
  }, (textToDisplay.numberMore > 0 ? textToDisplay.numberMore + ' ' : '') + moreText))) : null) : placeHolder || /*#__PURE__*/_react.default.createElement("div", null);
}